module.exports = __webpack_public_path__ + "static/media/eng_d_2244.b8d1f36f.vtt";